"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromWebToken = void 0;
const credential_provider_web_identity_1 = require("@aws-sdk/credential-provider-web-identity");
const fromWebToken = (init) => (0, credential_provider_web_identity_1.fromWebToken)({
    ...init,
});
exports.fromWebToken = fromWebToken;
